import { simpleUserFragment } from './fragmentsUser';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const grantUserAdminAccessMutationAtom = createMutationAtomFactory(
  'admin.grantUserAdminAccess',
  (params: { organizationId: string; userId: string }) => ({
    coreOrganizationGrantUserAdmin: {
      __args: {
        organizationId: params.organizationId,
        userId: params.userId,
      },
      ...simpleUserFragment,
    },
  }),
);

export const revokeUserAdminAccessMutationAtom = createMutationAtomFactory(
  'admin.revokeUserAdminAccess',
  (params: { organizationId: string; userId: string }) => ({
    coreOrganizationRevokeUserAdmin: {
      __args: {
        organizationId: params.organizationId,
        userId: params.userId,
      },
      ...simpleUserFragment,
    },
  }),
);
